module.exports = __webpack_public_path__ + "202408221624/img/loading.b69b59a2.svga";